import withSharedStyles from "../theme/Shared.style";

const withCustomStyles = withSharedStyles(() => ({
  root: {
    width: "100%",
    marginBottom: 16
  }
}));

export default withCustomStyles;
